import { doAction, doResponseAction } from ".";

const EDIT_HOSTELLER_REQUEST = 'EDIT_HOSTELLER_REQUEST';
const EDIT_HOSTELLER_SUCCESS = 'EDIT_HOSTELLER_SUCCESS';
const EDIT_HOSTELLER_FAILURE = 'EDIT_HOSTELLER_FAILURE';

const ADD_NEW_PERSON_REQUEST = 'ADD_NEW_PERSON_REQUEST';
const ADD_NEW_PERSON_SUCCESS = 'ADD_NEW_PERSON_SUCCESS';
const ADD_NEW_PERSON_FAILURE = 'ADD_NEW_PERSON_FAILURE';

const GET_VIDEO_LINK_REQUEST = 'GET_VIDEO_LINK_REQUEST';
const GET_VIDEO_LINK_SUCCESS = 'GET_VIDEO_LINK_SUCCESS';
const GET_VIDEO_LINK_FAILURE = 'GET_VIDEO_LINK_FAILURE';

const APPROVAL_REQUEST = 'APPROVAL_REQUEST';
const APPROVAL_SUCCESS = 'APPROVAL_SUCCESS';
const APPROVAL_FAILURE = 'APPROVAL_FAILURE';

export {
    EDIT_HOSTELLER_REQUEST,
    EDIT_HOSTELLER_SUCCESS,
    EDIT_HOSTELLER_FAILURE,
    ADD_NEW_PERSON_REQUEST,
    ADD_NEW_PERSON_SUCCESS,
    ADD_NEW_PERSON_FAILURE,
    GET_VIDEO_LINK_REQUEST,
    GET_VIDEO_LINK_SUCCESS,
    GET_VIDEO_LINK_FAILURE,
    APPROVAL_FAILURE,
    APPROVAL_REQUEST,
    APPROVAL_SUCCESS
}

export const editHostellerRequest = (params, callback) => doAction(EDIT_HOSTELLER_REQUEST, params, callback);
export const editHostellerSuccess = (data = {}) => doResponseAction(EDIT_HOSTELLER_SUCCESS, data);
export const editHostellerFailure = (data = {}) => doResponseAction(EDIT_HOSTELLER_FAILURE, data);

export const addNewPersonRequest = (params, callback) => doAction(ADD_NEW_PERSON_REQUEST, params, callback);
export const addNewPersonSuccess = (data = {}) => doResponseAction(ADD_NEW_PERSON_SUCCESS, data);
export const addNewPersonFailure = (data = {}) => doResponseAction(ADD_NEW_PERSON_FAILURE, data);

export const getPersonVideoRequest = (params, callback) => doAction(GET_VIDEO_LINK_REQUEST, params, callback);
export const getPersonVideoSuccess = (data = {}) => doResponseAction(GET_VIDEO_LINK_SUCCESS, data);
export const getPersonVideoFailure = (data = {}) => doResponseAction(GET_VIDEO_LINK_FAILURE, data);

export const sendApprovalRequest = (params, callback) => doAction(APPROVAL_REQUEST, params, callback);
export const sendApprovalSuccess = (data = {}) => doResponseAction(APPROVAL_SUCCESS, data);
export const sendApprovalFailure = (data = {}) => doResponseAction(APPROVAL_FAILURE, data);
